/** IE 브라우저 여부 */
export const isIEUser = (): boolean => {
  return navigator.userAgent.indexOf('Trident') > -1;
};

/** iframe 내부 실행 여부 */
export const isIframe = (): boolean => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};
